import React from 'react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CommonTable from '../common/components/CommonTable';
import GroupsTableRow from './GroupsTableRow';
import { PrepareUrl } from '../common/helpers/PrepareUrl';
import RouterPaths from '../constants/RouterPaths';
import CommonLoader from '../common/components/CommonLoader';
import { SET_GROUP_SEARCH_STATE } from './GroupsReducer';

const headers = [
  {
    label: 'ID',
  },
  {
    label: 'Name',
  },
  {
    label: 'Actions',
    className: 'text-right',
  },
];

const GroupsTable = ({ data, offset, changeOffset, history, searchParams }) => {
  const dispatch = useDispatch();
  const loaderStatus = useSelector(state => state.groups.get('loaderStatus'));
  return (
    <Row>
      <Col xs="12">
        <CommonLoader status={loaderStatus}>
          <CommonTable
            rowIdPrefix="group-row"
            rowComponent={GroupsTableRow}
            data={data}
            offset={offset}
            onOffsetChange={changeOffset}
            headers={headers}
            title="Groups"
            handleRowClick={item => {
              dispatch({
                type: SET_GROUP_SEARCH_STATE,
                payload: {
                  groupId: item.id,
                  searchParams,
                },
              });
              history.push(PrepareUrl(RouterPaths.EDIT_GROUP, { id: item.id }));
            }}
          />
        </CommonLoader>
      </Col>
    </Row>
  );
};

GroupsTable.propTypes = {
  data: PropTypes.object.isRequired,
  offset: PropTypes.number.isRequired,
  changeOffset: PropTypes.func.isRequired,
};

export default withRouter(GroupsTable);
